import React, { Component, Fragment } from 'react';
import Button from 'react-bootstrap/lib/Button';
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup';
import map from 'lodash.map';
import isEqual from 'lodash.isequal';
import orderBy from 'lodash.orderby';
import findIndex from 'lodash.findindex';
import get from 'lodash.get';
import { Select } from '../../Select';
import ProjectListItem from './ProjectListItem';
import { ProjectMode, VoteMode, ThematicAreaDropdownOption, ProjectType, ExpendActionType } from '../../../utils/enums';
import { Loader } from '../../Loader';
import { Button as CancelButton } from '../../Button';
import { ButtonLoader } from '../../ButtonLoader';
import { Pagination } from '../../Pagination';
import { PaginationSelect } from '../../PaginationSelect';
import ProjectListProbeItem from './ProjectListProbeItem';

export class ProjectList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			category: ThematicAreaDropdownOption.NotSetted,
			voteMode: VoteMode.NotSetted,
			projectMode: ProjectMode.NotSetted,
			searchTerm: '',
			titles: this.getTitles(props.projectType),
			categories: map(props.thematicAreas, (item) => ({ value: item.id, text: item.name })),
			opened: true,
			archiveOpened: false
		};
		this.handleSelect = (fieldName, option) => {
			this.setState({
				[fieldName]: option.value
			});
		};
		this.handleChange = (event) => {
			this.setState({
				searchTerm: event.target.value
			});
		};
		this.onSearchClick = (e) => {
			e.preventDefault();
			this.props.onSearchProject({
				category: this.state.category,
				voteMode: this.state.voteMode,
				projectMode: this.state.projectMode,
				searchTerm: this.state.searchTerm,
				page: 1,
				size: this.props.size,
				archiveListPage: this.props.archiveListPage,
				archiveListSize: this.props.archiveListSize
			});
		};
		this.handlePageSizeChanged = this.handlePageSizeChanged.bind(this);
		this.handleArchivePageSizeChanged = this.handleArchivePageSizeChanged.bind(this);
		this.toggleOpen = (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.setState({
				opened: !this.state.opened
			});
		};
		this.toggleOpenArchive = (e) => {
			e.preventDefault();
			e.stopPropagation();
			const propertyName = this.getPropertyName(this.props.projectType, true);
			this.setExpandStateItem(
				propertyName,
				!this.state.archiveOpened ? ExpendActionType.add : ExpendActionType.remove,
				-1
			);
		};

		this.getPropertyName = this.getPropertyName.bind(this);
		this.setExpandStateItem = this.setExpandStateItem.bind(this);
	}
	componentDidMount() {
		const oldPropertyName = this.getPropertyName(this.props.projectType, true);
		const archiveOpened = this.props.expand[oldPropertyName].some((item) => item === -1);
		this.setState({
			archiveOpened: archiveOpened
		});
	}
	componentDidUpdate(prevProps) {
		if (prevProps.projectType !== this.props.projectType) {
			this.setState({
				titles: this.getTitles(this.props.projectType)
			});
		}

		if (!isEqual(prevProps.thematicAreas, this.props.thematicAreas)) {
			this.setState({
				categories: map(this.props.thematicAreas, (item) => ({ value: item.id, text: item.name }))
			});
		}

		if (!isEqual(prevProps.expand, this.props.expand)) {
			const oldPropertyName = this.getPropertyName(this.props.projectType, true);
			const archiveOpened = this.props.expand[oldPropertyName].some((item) => item === -1);
			this.setState({
				archiveOpened: archiveOpened
			});
		}
	}

	paginationGoTo(filter) {
		this.props.onSearchProject({
			category: filter.category,
			voteMode: filter.voteMode,
			projectMode: filter.projectMode,
			searchTerm: filter.searchTerm,
			page: filter.page,
			size: filter.size,
			archiveListPage: this.props.archiveListPage,
			archiveListSize: this.props.archiveListSize
		});
	}

	renderButtons(cell, row) {
		return (
			<span>
				<ButtonGroup>
					<Button variant="primary" onClick={() => this.props.onProjectDetails(row)}>
						Szczegóły
					</Button>
				</ButtonGroup>
			</span>
		);
	}

	getTitles(projectType) {
		switch (projectType) {
			case ProjectType.Consultation:
				return {
					activeTitle: 'Konsultacje w toku',
					archiveTitle: 'Zakończone konsultacje',
					linkTitle: 'Przejdź do konsultacji'
				};
			case ProjectType.Probe:
				return {
					activeTitle: 'Sondy w toku',
					archiveTitle: 'Zakończone sondy',
					linkTitle: 'Przejdź do sondy'
				};
			case ProjectType.Survey:
				return {
					activeTitle: 'Ankiety w toku',
					archiveTitle: 'Zakończone ankiety',
					linkTitle: 'Przejdź do ankiety'
				};
			default:
				return {
					activeTitle: 'Konsultacje w toku',
					archiveTitle: 'Zakończone konsultacje'
				};
		}
	}

	_handleInvalid(e) {
		e.target.setCustomValidity('');
		if (!e.target.validity.valid) {
			if (!e.target.value) {
				e.target.setCustomValidity('Pole jest wymagane');
			} else if (e.target.value.length < 3) {
				e.target.setCustomValidity('Minimalna długość zapytania to 3 znaki');
			}
		}
	}

	handlePageSizeChanged(option) {
		this.props.changePageSize(option.value);
	}

	handleArchivePageSizeChanged(option) {
		this.props.changeArchivePageSize(option.value);
	}

	getPropertyName(type, isOld) {
		let propertyName = '';
		switch (type) {
			case ProjectType.Probe: {
				propertyName = !isOld ? 'probes' : 'oldprobes';
				break;
			}
			case ProjectType.Consultation: {
				propertyName = !isOld ? 'consultations' : 'oldconsultations';
				break;
			}
			case ProjectType.Survey: {
				propertyName = !isOld ? 'surveys' : 'oldsurveys';
				break;
			}
			case ProjectType.PublicBudget: {
				propertyName = !isOld ? 'budgets' : 'oldbudgets';
				break;
			}
			default: {
				propertyName = '';
				break;
			}
		}
		return propertyName;
	}

	setExpandStateItem(propertyName, action, id) {
		this.props.onSetExpandStateItem(action, propertyName, id);
	}
	render() {
		const {
			projectType,
			isAuth,
			isProjectListLoading,
			isSearching,
			loggedOfficeId,
			loggedUserId,
			thematicAreas,
			projects,
			archiveProjects,
			page,
			size,
			archiveListPage,
			archiveListSize,
			totalProjects,
			totalArchiveProjects,
			availableProjectModes,
			availablePublishProgress,
			changePageSize,
			changeArchivePageSize,
			onSearchProject,
			onSearchArchiveProject,
			onProjectPreview,
			onProjectVote,
			isCancelButtonVisible,
			isArchiveProjectLoading,
			isOnlyOneOffice,
			voteExecuting,
			onSaveProjectVote,
			expand,
			onSetExpandStateItem,
			loggedUserIsCitizen
		} = this.props;
		const { titles, categories, opened, archiveOpened } = this.state;
		const totalPages = Math.ceil(totalProjects / size);
		const totalArchivePages = Math.ceil(totalArchiveProjects / archiveListSize);
		const voteModeOptions =
			projectType === ProjectType.Consultation
				? [
						{ value: VoteMode.Part, text: 'Częściowo' },
						{ value: VoteMode.NoVote, text: 'Nie' },
						{ value: VoteMode.Complete, text: 'Tak' }
					]
				: [ { value: VoteMode.NoVote, text: 'Nie' }, { value: VoteMode.Complete, text: 'Tak' } ];
		return (
			<Fragment>
				{isProjectListLoading && <Loader loading={isProjectListLoading} />}
				{!isProjectListLoading && (
					<div id="content" className="container consultations">
						<form onSubmit={this.onSearchClick}>
							<div className="row row--justify-end row--space-10 row--top-15 row--bottom-20 surveys__filters">
								<Select
									id="search-project-mode-select"
									options={[
										{ value: ProjectMode.NotSetted, text: '[Wszystkie tryby]' },
										{ value: ProjectMode.Open, text: 'Otwarty' },
										{ value: ProjectMode.Citizen, text: 'Tylko dla mieszkańca' },
										{ value: ProjectMode.Close, text: 'Zamknięty' }
									]}
									value={this.state.projectMode}
									onSelect={(option) => this.handleSelect('projectMode', option)}
								/>
								{isAuth && (
									<Select
										id="search-vote-mode-select"
										options={[
											{ value: VoteMode.NotSetted, text: '[Wszystkie opcje oddania głosu]' },
											...voteModeOptions
										]}
										value={this.state.voteMode}
										onSelect={(option) => this.handleSelect('voteMode', option)}
									/>
								)}
								{projectType === ProjectType.Consultation && (
									<Select
										id="search-category-select"
										options={[
											{
												value: ThematicAreaDropdownOption.NotSetted,
												text: '[Wszystkie kategorie]'
											},
											...orderBy(categories, [ 'text' ])
										]}
										value={this.state.category}
										onSelect={(option) => this.handleSelect('category', option)}
									/>
								)}
								<div className="field">
									<input
										className="field__input"
										placeholder="Słowa kluczowe"
										title="Wpisz słowa kluczowe"
										type="text"
										value={this.state.searchTerm}
										onChange={this.handleChange.bind(this)}
										pattern=".{3,}"
										onInvalid={this.handleInvalid}
									/>
								</div>
								{!isSearching && (
									<button
										id="search-button"
										className="button button--primary-dark button--16 button--width-auto"
										type="submit"
										tabIndex="0"
										title="Wyszukaj z zastosowanymi filtrami"
									>
										<span aria-hidden="true">Wyszukaj</span>
									</button>
								)}
								{isSearching && (
									<ButtonLoader
										isExecuting={isSearching}
										executingText="Szukanie"
										color={'#fff'}
										className="button button--danger button--16 button--width-auto"
									/>
								)}
							</div>
						</form>
						<Fragment>
							<div className="consultations__item">
								<div className={`consultations__header`} onClick={this.toggleOpen}>
									<div className="consultations__title">{titles.activeTitle}</div>
									<div className="consultations__icons">
										<div className="consultations__switch consultations__switch--primary-dark" onClick={this.toggleOpen}>
											{opened ? 'Zwiń' : 'Rozwiń'}
											{
												<i
													className={`consultations__icon fas fa-angle-${opened
														? 'up'
														: 'down'}`}
												/>
											}
										</div>
									</div>
								</div>
								{opened && (
									<Fragment>
										<div className="consultations__body">
											{totalProjects === 0 && (
												<div className="text text--weight-700">
													Brak projektów spełniających warunek
												</div>
											)}
											{projectType !== ProjectType.Probe &&
												map(orderBy(projects, [ 'dateTo', 'status' ]), (project, index) => {
													if (project.type !== ProjectType.PublicBudget) {
														return (
															<ProjectListItem
																key={`active-project-${index}`}
																{...project}
																isAuth={isAuth}
																loggedOfficeId={loggedOfficeId}
																loggedUserIsCitizen={loggedUserIsCitizen}
																onProjectPreview={onProjectPreview}
																onProjectVote={onProjectVote}
																isOnlyOneOffice={isOnlyOneOffice}
															/>
														);
													}
												})}
											{projectType === ProjectType.Probe &&
												map(orderBy(projects, [ 'dateTo', 'status' ]), (project, index) => {
													let consultationFormId = get(
														project,
														'consultationForms[0].id',
														-1
													);
													let isExecuting =
														findIndex(voteExecuting, (id) => id === consultationFormId) !==
														-1;
													return (
														<ProjectListProbeItem
															key={`probe-project-${index}`}
															{...project}
															isAuth={isAuth}
															isExecuting={isExecuting}
															loggedOfficeId={loggedOfficeId}
															loggedUserId={loggedUserId}
															loggedUserIsCitizen={loggedUserIsCitizen}
															onProjectPreview={onProjectPreview}
															onProjectVote={onProjectVote}
															isOnlyOneOffice={isOnlyOneOffice}
															onSaveProjectVote={onSaveProjectVote}
														/>
													);
												})}
										</div>
										<div className="projects__pagination row row--align-center row--justify-space row--top-20">
											<PaginationSelect
												id="active-project-pagination"
												onPageSizeChanged={this.handlePageSizeChanged}
												size={size}
											/>
											<Pagination
												currentPage={parseInt(page)}
												totalPages={totalPages}
												nextAction={() =>
													this.paginationGoTo({
														...this.state,
														page: parseInt(page) + 1,
														size: parseInt(size)
													})}
												prevAction={() =>
													this.paginationGoTo({
														...this.state,
														page: parseInt(page) - 1,
														size: parseInt(size)
													})}
											/>
										</div>
									</Fragment>
								)}
							</div>

							<div className="consultations__item">
								<div className={`consultations__header`} onClick={this.toggleOpenArchive}>
									<div className="consultations__title">{titles.archiveTitle}</div>
									<div className="consultations__icons">
										<div className="consultations__switch consultations__switch--primary-dark" onClick={this.toggleOpenArchive}>
											{archiveOpened ? 'Zwiń' : 'Rozwiń'}
											{
												<i
													className={`consultations__icon fas fa-angle-${archiveOpened
														? 'up'
														: 'down'}`}
												/>
											}
										</div>
									</div>
								</div>
								{isArchiveProjectLoading &&
								archiveOpened && <Loader loading={isArchiveProjectLoading} />}
								{!isArchiveProjectLoading &&
								archiveOpened && (
									<div className="consultations__body">
										{totalArchiveProjects === 0 && (
											<div className="text text--weight-700">
												Brak projektów spełniających warunek
											</div>
										)}
										<div className="consultations__item">
											<div className="consultations__body">
												{projectType !== ProjectType.Probe &&
													map(orderBy(archiveProjects, [ 'dateTo', 'status' ]), (project) => {
														const propertyName = this.getPropertyName(project.type, true);
														const opened = expand[propertyName].some(
															(item) => item === project.id
														);
														return (
															<ProjectListItem
																key={`archive-project-${project.id}`}
																{...project}
																isActual={false}
																isAuth={isAuth}
																loggedOfficeId={loggedOfficeId}
																loggedUserIsCitizen={loggedUserIsCitizen}
																onProjectPreview={onProjectPreview}
																onProjectVote={onProjectVote}
																isOnlyOneOffice={isOnlyOneOffice}
																opened={opened}
																onSetExpandStateItem={(action, id) =>
																	this.setExpandStateItem(propertyName, action, id)}
															/>
														);
													})}
												{projectType === ProjectType.Probe &&
													map(orderBy(archiveProjects, [ 'dateTo', 'status' ]), (project) => {
														const propertyName = this.getPropertyName(project.type, true);
														const opened = expand[propertyName].some(
															(item) => item === project.id
														);
														return (
															<ProjectListProbeItem
																key={`archive-project-${project.id}`}
																{...project}
																isActual={false}
																isAuth={isAuth}
																loggedOfficeId={loggedOfficeId}
																loggedUserIsCitizen={loggedUserIsCitizen}
																onProjectPreview={onProjectPreview}
																onProjectVote={onProjectVote}
																isOnlyOneOffice={isOnlyOneOffice}
																onSaveProjectVote={onSaveProjectVote}
																opened={opened}
																onSetExpandStateItem={(action, id) =>
																	this.setExpandStateItem(propertyName, action, id)}
															/>
														);
													})}
											</div>
										</div>
										<div className="projects__pagination row row--align-center row--justify-space row--top-20">
											<PaginationSelect
												id="closed-project-pagination"
												onPageSizeChanged={this.handleArchivePageSizeChanged}
												size={archiveListSize}
											/>
											<Pagination
												currentPage={parseInt(archiveListPage)}
												totalPages={totalArchivePages}
												nextAction={() =>
													this.props.onSearchArchiveProject({
														...this.state,
														page: parseInt(page),
														size: parseInt(size),
														archiveListPage: parseInt(archiveListPage) + 1,
														archiveListSize: parseInt(archiveListSize)
													})}
												prevAction={() =>
													this.props.onSearchArchiveProject({
														...this.state,
														page: parseInt(page),
														size: parseInt(size),
														archiveListPage: parseInt(archiveListPage) - 1,
														archiveListSize: parseInt(archiveListSize)
													})}
											/>
										</div>
									</div>
								)}
							</div>
						</Fragment>
						{isCancelButtonVisible && (
							<div className="buttons margin-top-10 margin-bottom-20">
								<CancelButton
									className="button button--16 button--width-auto button--bordered-transparent button--danger"
									onClick={this.props.onCancel}
								>
									Powrót
								</CancelButton>
							</div>
						)}
					</div>
				)}
			</Fragment>
		);
	}
}
ProjectList.defaultProps = {
	projectType: ProjectType.CitizenInitiative,
	isAuth: false,
	isProjectListLoading: false,
	isSearching: false,
	isCancelButtonVisible: false,
	isArchiveProjectLoading: false,
	isOnlyOneOffice: false,
	loggedOfficeId: 0,
	loggedUserId: -1,
	loggedUserIsCitizen: false,
	thematicAreas: [],
	projects: [],
	archiveProjects: [],
	page: 1,
	size: 10,
	archiveListPage: 1,
	archiveListSize: 10,
	totalProjects: 0,
	totalArchiveProjects: 0,
	availableProjectModes: [],
	availablePublishProgress: [],
	expand: {
		budgets: [],
		oldbudgets: [],
		consultations: [],
		oldconsultations: [],
		surveys: [],
		oldsurveys: [],
		probes: [],
		oldprobes: []
	},
	changePageSize: Function.prototype,
	changeArchivePageSize: Function.prototype,
	onSearchProject: Function.prototype,
	onSearchArchiveProject: Function.prototype,
	onProjectPreview: Function.prototype,
	onProjectVote: Function.prototype,
	onSaveProjectVote: Function.prototype,
	onCancel: Function.prototype,
	onSetExpandStateItem: Function.prototype
};
